(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.logos.controller:LogosCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.logos')
    .controller('EntitatsMainLogosCtrl', EntitatsMainLogosCtrl);

  function EntitatsMainLogosCtrl(logosData, LogoFactory, $scope, $stateParams, $rootScope, HelperFactory, $state, AdmConstant,Notification) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLogosCtrl';

    vm.add = add;

    vm.logos = logosData.data.list;

    vm.baseUrlUpload = '/api/' + AdmConstant.SERVER_PATH_ADMINISTRACIO;
    vm.controllerUrlUpload = 'entitats/' + $stateParams.idEntitat + '/logos';
    vm.idEntitat = $stateParams.idEntitat;
    vm.makeLogoPred = function(id){
      LogoFactory.makeLogoPredeterminat(vm.idEntitat, id).then(function (response){
        Notification.success('GENERIC_SUCCESS');
        $scope.$evalAsync(function(){
          for (var i = 0; i < vm.logos.length; i++){
            vm.logos[i].predeterminat = vm.logos[i].id === id;
          }
        });
      }).catch(function (response){
        Notification.error('GENERIC_ERROR_UNEXPECTED_EXCEPTION');
      });
    }

    vm.uploadEndFunction = function(){
      LogoFactory.getAll(vm.idEntitat).then(function(response){
        $scope.$evalAsync(function(){
          vm.logos = response.data.list;
        });
      }).catch(function(error){
        Notification.processError(error);
      });
    }

    function add(){
      HelperFactory.setParams($stateParams, {'isNew': true});
      $state.go('entitats.main.submain.logos.formulari', $stateParams, {'reload': 'entitats.main.submain.logos'});
    }

    if (angular.isUndefined(vm.idEntitat) || vm.idEntitat === null || !vm.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  }
}());
